import React from 'react';
import TooltipBody from 'modules/emergencies/components/ui/texts/TooltipBody';
import TooltipHeader from 'modules/emergencies/components/ui/texts/TooltipHeader';
import { getUserName } from '../utils/user';

export const AgentCreationTooltip = ({ ticket }) => {
  const id = ticket?.created_by?.id;
  const head = 'Created by';
  const body = id ? getUserName(ticket?.created_by) : 'Not Defined';
  return (
    <>
      <TooltipHeader>{head}</TooltipHeader>
      <TooltipBody>{body}</TooltipBody>
    </>
  );
};
